import endpoint from "../../../config/endpoints";
import { areYouSureMsg, saveFailedMsg } from "../../../config/messageconstant";
import { apiPost } from "../../../utils/api_service";
import {
	buildBillingPayload,
	mapOfferBillResponse,
} from "./advanceOutletInvoicingUtils";

export const submitBillConfiguration = ({
	outletOrderDetail,
	flag,
	productStockData,
	billDate,
	billDiscountPercentage,
	warningText,
	showLoador,
	showNotification,
	onSwalConfirm,
	onSuccess,
}) => {
	const dataToSave = buildBillingPayload({
		outletOrderDetail,
		flag,
		productStockData,
	});

	swal({
		title: areYouSureMsg,
		text: warningText,
		icon: "warning",
		buttons: true,
		dangerMode: true,
	}).then(async (willDelete) => {
		if (!willDelete) {
			return;
		}

		onSwalConfirm?.();

		showLoador({ loador: true });
		await apiPost({
			url:
				`${endpoint.outletBillHeader}/generate-with-applied-with-new-offers-optimize` +
				`?billDate=${billDate}&billDiscountPercentage=${billDiscountPercentage}`,
			postBody: dataToSave,
		}).then(({ data, success }) => {
			if (!success) {
				showLoador({ loador: false });
				showNotification({ msg: saveFailedMsg, severity: "error" });
				return;
			}

			if (Object.keys(data).length === 0 || data.data.length === 0) {
				showLoador({ loador: false });
				return;
			}

			onSuccess(mapOfferBillResponse(data.data));
		});
	});
};
